import React from "react";
import Sidebar from "../../components/Sidebar/SidebarComponent";
import ToolbarComponent from "../../components/Toolbar/ToolbarComponent";
import CanvasComponent from "../../components/Canvas/CanvasComponent";
import styled from "styled-components";

const EditorPageLayout = styled.div`
  display: flex;
  flex-direction: row;

  background: #fff;
  width: 90%;
  height: 90%;
`;

const EditorLayout = styled.div`
  display: flex;
  flex-direction: column;
  background: yellow;
  flex: 1;
`;

const SidebarLayout = styled.div`
  display: flex;
  flex-direction: row;
  background: #fff;
  flex: 0 0 200px;
  height: 100%;
  border-right: 1px solid #f5f5f5;
`;
const ToolbarLayout = styled.div`
  display: flex;
  flex-direction: row;
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
  flex: 0 0 50px;
  align-items: center;
  padding: 0 12px;
`;
const CanvasLayout = styled.div`
  flex: 1;
  background: #fff;

  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

function EditorComponent() {
  const [dimensions, setDimensions] = React.useState(null);
  const useCanvasLayoutRef = React.useCallback((ref) => {
    if (ref !== null) {
      setDimensions({
        width: ref.offsetWidth,
        height: ref.offsetHeight,
      });
    }
  }, []);
  return (
    <EditorPageLayout>
      <SidebarLayout>
        <Sidebar></Sidebar>
      </SidebarLayout>
      <EditorLayout>
        <ToolbarLayout>
          <ToolbarComponent />
        </ToolbarLayout>
        <CanvasLayout ref={useCanvasLayoutRef}>
          <CanvasComponent dimensions={dimensions} />
        </CanvasLayout>
      </EditorLayout>
    </EditorPageLayout>
  );
}

export default EditorComponent;
